import React from 'react'
import PropTypes from 'prop-types';
import SVGInline from 'react-svg-inline';
import cx from 'classnames';
import './Icon.css';
import cssVars from '../../../assets/export.css';



/**
 * A simple Icon. Place SVG files in svg folder.
 */

const Icon = ({ className, filename, size, color, ...otherProps }) => {
    const requireSVGs = require.context("./svg", false, /\.svg$/);
    const icon = requireSVGs(`./${filename}.svg`);
    return (<div
              style={{
                width: size
              }}
              className={cx({
                [`icon--${color}`]: true,
                [`icon--${filename}`]: true,
                'icon': true
              })}
              {...otherProps}
            >
            <SVGInline svg={ icon } fill={color} cleanup />
          </div>)
}

Icon.propTypes = {
  /** actual filename of the Icon, will be used as reference for the filename `filename.svg` */
  filename: PropTypes.string.isRequired,
  /** width of displayed Icon */
  size: PropTypes.string,
  /** fillColor */
  color: PropTypes.string,
  /** additional classnames, optional */
  className: PropTypes.string,
}

Icon.defaultProps = {
  filename: 'close',
  size: '24px',
  color: cssVars.brandPrimary,
  className: ''
};

export default Icon;



// WEBPACK FOOTER //
// ./src/components/atoms/Icon/Icon.js